import Autocomplete, {
  AutocompleteChangeReason,
  createFilterOptions,
} from "@mui/material/Autocomplete";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import CommonTextField from "../commonTextField/CommonTextField";
import { Option } from "./types";

const filter = createFilterOptions<Option>();

type Props = {
  onChange: (
    event: ChangeEvent<{}>,
    newValue: Option | null,
    dialogValue: { dialogOpen: boolean; dialogValue: string },
    reason: AutocompleteChangeReason,
    details?: any,
  ) => void;
  value: Option;
  options: Option[];
};

const CustomAutocompleteFreeSolo = ({ onChange, value, options }: Props) => {
  const { t } = useTranslation();

  return (
    <Autocomplete
      value={value}
      isOptionEqualToValue={(option, value) => {
        const optionId = typeof option === "string" ? option : option?.id;
        const valueId = typeof value === "string" ? value : value.id;
        return optionId === valueId;
      }}
      onChange={(event, newValue, reason) => {
        const currentValue = newValue as Option;
        if (currentValue?.inputValue) {
          onChange(
            event,
            currentValue,
            { dialogOpen: true, dialogValue: currentValue.inputValue },
            reason,
          );
        } else {
          onChange(
            event,
            currentValue,
            { dialogOpen: false, dialogValue: "" },
            reason,
          );
        }
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        if (params.inputValue !== "") {
          filtered.push({
            inputValue: params.inputValue,
            name: `${t("common:add")} "${params.inputValue}"`,
            id: "",
          });
        }

        return filtered;
      }}
      options={options}
      getOptionLabel={(option) => {
        // e.g value selected with enter, right from the input
        if (typeof option === "string") {
          return option;
        }
        if (option.inputValue) {
          return option.inputValue;
        }
        return option.name;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.name}
        </li>
      )}
      freeSolo
      renderInput={(params) => <CommonTextField {...params} />}
    />
  );
};

export default CustomAutocompleteFreeSolo;
